import { Component, Children } from 'react';
import PropTypes from 'prop-types';

class UserProvider extends Component {
  static childContextTypes = {
    user: PropTypes.object.isRequired,
  }
  getChildContext() {
    const { user } = this.props;
    return { user };
  }
  render() {
    return Children.only(this.props.children);
  }
}

export default UserProvider;



// WEBPACK FOOTER //
// ./src/Auth/user.provider.js